// extracted by mini-css-extract-plugin
export default {"wrapper":"kk","form":"lk","required":"mk","label":"nk","noMargin":"ok","success":"pk","circle":"qk","successText":"rk","smallprint":"sk"};